import { post } from './axios';

import { createGlobalPayload } from './_payload';

const payloadWhoAmI = function() {
    return createGlobalPayload("user", "whoAmI", {});
}

const fetchWhoAmI = async () => {
    const response = await post("/", payloadWhoAmI()).catch( (err) => false);
    if(response === false) return false;

    return response;
}

export {
    fetchWhoAmI
}